import { ActionType, createReducer } from 'typesafe-actions';
import * as actions from '../../actions/accountPhoneBook';
import { PhonebookRecord } from '../../actions/accountPhoneBook/payloads';

export interface AccountPhoneBookStateType {
    list?: PhonebookRecord[]; 
    total?: number;
    isLoading?: boolean;
    isSaving?: boolean;
    isDeleting?: boolean;
}

export const initialState: AccountPhoneBookStateType = {
    isLoading: false,
};

export type AccountPhoneBookActionsType = ActionType<typeof actions>;

const accountPhoneBookReducer = createReducer<
    AccountPhoneBookStateType,
    AccountPhoneBookActionsType
>(initialState)
    .handleAction(actions.getAccountPhoneBookList.request, (state) => ({
        ...state,
        isLoading: true,
    }))
    .handleAction(actions.getAccountPhoneBookList.success, (state, action) => ({
        ...state,
        list: action.payload.list,
        total: action.payload.total,
        isLoading: false
    }))
    .handleAction(actions.getAccountPhoneBookList.failure, (state) => ({
        ...state,
        isLoading: false
    }));

export default accountPhoneBookReducer;
